import { useTransaction } from 'context/transactionContext'
import { useEffect, useState } from 'react'

export default function Alerts({ color = 'slate', message, data = [], badge }) {
	const [showAlert, setShowAlert] = useState(true)
	const { setMessages } = useTransaction()

	useEffect(() => {
		setTimeout(() => {
			setShowAlert(false)
			setMessages({})
		}, 5000)
	}, [showAlert])

	return (
		<>
			{showAlert ? (
				<div
					className={`flex items-center justify-between text-white w-full p-4 border-0 rounded-md bg-${color}-500`}
				>
					<div className='w-4/5 flex align-middle'>
						<span
							className={`flex rounded-full bg-${color}-400 uppercase px-2 py-2 align-middle text-xs font-bold mr-3`}
						>
							{badge}
						</span>
						{data.length > 0 && (
							<div className='px-2'>
								<ul>
									{data.map((item, index) => {
										return <li key={index}>{item.name} is</li>
									})}
								</ul>
							</div>
						)}
						<span className='font-bold align-middle mr-8'>{message}</span>
					</div>
					<button
						className='bg-transparent text-2xl font-semibold leading-none align-middle outline-none focus:outline-none'
						onClick={() => setShowAlert(false)}
					>
						<span className='px-2 py-2 align-middle'>×</span>
					</button>
				</div>
			) : null}
		</>
	)
}
